export default __webpack_public_path__ + "static/media/notification_icon.232e4515.svg";